import Repository from './Repository'
import { API_BASE_PATH } from './ApiPath'

const ADMIN = API_BASE_PATH.ADMIN

export default {
  login(data: any) {
    return Repository.post(`${ADMIN}/login`, data)
  },
  logout() {
    return Repository.get(`${ADMIN}/logout`)
  }
}